<template>
  <div id="app">
    <NavigationTop :path="path"/>
    <div class="content-block">
      <router-view/>
    </div>
    <MyFooter />
  </div>
</template>

<script>
  // @ is an alias to /src
  // import HelloWorld from '@/components/HelloWorld.vue'
  import NavigationTop from '@/components/NavigationTop/NavigationTop.vue'
  import {getLocalLang} from "./common/common";
  import MyFooter from "./components/Footer/MyFooter";

  export default {

    data() {
      return {
        path: '',
      }
    },

    created() {
      // 获取浏览器本地语言信息并缓存到浏览器
      this.setLocalLang();

      this.path = this.$route.path;
      console.log('route path: ', this.path)
    },

    methods: {
      // // 获取浏览器本地语言信息并缓存到浏览器
      setLocalLang() {
        getLocalLang();
        // 设置语言
        this.$i18n.locale = localStorage.getItem('lang');
      },
      

    },

    components: {
      MyFooter,
      NavigationTop,
    }
  }
</script>

<style lang="scss">
  @import "assets/style/mainStyle.scss";

  *, body {
    margin: 0;
    padding: 0;
    font-size: 10px;
    font-family: 'Droid Sans',Helvetica,sans-serif;
  }
  #app {
    background-color: $backgroundColor;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  ul li {
    list-style: none;
  }
  a {
    text-decoration: none;
  }
  .content-block {
    flex: 1;
    padding-top: 59px;
    background-color: $mainColorDark;
  }
  .line-wrapper {
    margin: 10px 0;
  }
  .line {
    height: 1px;
    background-color: #DBDBDA;
  }
  .col-line {
    width: 1px;
    background-color: #DBDBDA;
    margin: 0 10px;
  }
</style>
